// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module--logo--3x58T","logoLarge":"logo-module--logoLarge--2NG6b","logoSmall":"logo-module--logoSmall--3vVJV"};